import {View, StyleSheet} from 'react-native';
import Text from '@/components/basic/text';
import theme from '@/style';
import React from 'react';

export interface CardsProps {
  closed?: boolean;
  title?: string;
  tip?: string;
  digit?: string;
}

const Cards = ({title, tip, closed, digit}: CardsProps) => {
  const bottomBg = React.useMemo(() => {
    return closed ? '#C9CED3' : '#E91100';
  }, [closed]);

  const borderColor = React.useMemo(() => {
    return closed ? '#C9CED3' : '#E91100';
  }, [closed]);

  const textColor = closed ? '#C9CED3' : theme.fontColor.main;
  const tipColor = closed ? '#C9CED3' : theme.fontColor.accent;

  return (
    <View style={[styles.container, theme.overflow.hidden, {borderColor}]}>
      <View style={[theme.flex.center, styles.top]}>
        <Text textAlign="center" style={[styles.title, {color: textColor}]}>
          {title}
        </Text>
        {!!tip && (
          <Text textAlign="center" style={[styles.tip, {color: tipColor}]}>
            {tip}
          </Text>
        )}
      </View>
      <View style={[styles.bottom, {backgroundColor: bottomBg}]}>
        <Text
          textAlign="center"
          color={theme.basicColor.white}
          style={styles.digit}>
          {closed ? '-' : digit}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderRadius: 8,
    width: '32%',
  },
  top: {
    height: 56,
    paddingHorizontal: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 14,
    lineHeight: 16,
  },
  tip: {
    marginTop: 2,
    fontSize: 12,
    lineHeight: 14,
  },
  bottom: {
    paddingVertical: 4,
    paddingHorizontal: 8,
  },
  digit: {
    fontSize: 14,
    lineHeight: 16,
  },
});

export default Cards;
